export default __webpack_public_path__ + "static/a92c60172bce40468980bfad983d840c.jpg";